export class LyantheInvoiceLineModel {
  lineNumber: number
  ledger: string
  VatCode: string
  VATPerc: string
  isPrivate: boolean
  amountExcl: number
  vat: string
  description: string

  constructor(data) {
    this.lineNumber = data.lineNumber ? data.lineNumber : null
    this.ledger = data.ledger ? data.ledger : null
    this.description = data.description ? data.description : null
    this.VatCode = data.VatCode ? data.VatCode : null
    this.VATPerc = data.VATPerc ? data.VATPerc : null
    this.vat = data.vat ? data.vat : null
    this.isPrivate = data.isPrivate ? data.isPrivate : null
    this.amountExcl = data.amountExcl ? data.amountExcl : null
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/lyanthe/lyanthe.invoice.line.model.ts